<div id="download" class="downnload-container container">
  <div class="download-app-section">
    <div class="download-left">
      <h1>{{ "download-app.download-and-explore" | translate }}</h1>
      <p>
        {{ "download-app.download-app-desc" | translate }}
      </p>
      <ul class="app-download">
        <li>
          <a
            href="https://play.google.com/store/apps/details?id=in.gov.umang.negd.g2c"
            target="_blank"
            title="Play Store"
          >
            <img
              class="resp-image saturate"
              imgFallback
              src="https://media.umangapp.in/cdn/landing/theme/icons/google-play-store.svg"
              alt="Play Store"
              loading="lazy"
              fetchpriority="low"
              width="143px"
              height="47px"
            />
          </a>
        </li>
        <li>
          <a
            href="https://itunes.apple.com/in/app/umang/id1236448857?mt=8"
            target="_blank"
            title="App Store"
          >
            <img
              imgFallback
              src="https://media.umangapp.in/cdn/landing/theme/icons/app-store.svg"
              alt="App Store"
              loading="lazy"
              fetchpriority="low"
              class="resp-image saturate"
              width="143px"
              height="47px"
            />
          </a>
        </li>
      </ul>

      <div class="social-media-col">
        <h6 class="foot-sub-heading flex-shrink-0 mb-0">
          {{ "download-app.follow-us" | translate }}:
        </h6>
        <ul class="menu-list-item mb-0">
          <li
            class="menu-list-items"
            *ngFor="let item of socialPages"
            (click)="socialLinkRedirect(item?.url)"
            [title]="item?.title"
            role="button"
          >
            <span class="sociaicon">
              <img
                imgFallback
                [src]="item?.img"
                loading="lazy"
                fetchpriority="low"
                [alt]="item?.alt"
                width="40"
                height="40"
              />
            </span>
            <span class="social-text" *ngIf="false">{{
              "footer.facebook" | translate
            }}</span>
          </li>
        </ul>
        <ul class="menu-list-item mb-0" *ngIf="false">
          <li class="menu-list-items menu-list-items--facebook">
            <a
              href="https://www.facebook.com/OfficialUmangApp"
              target="_blank"
              title="Facebook"
            >
              <span class="sociaicon">
                <img
                  imgFallback
                  src="https://media.umangapp.in/cdn/landing/theme/icons/facebook.svg"
                  loading="lazy"
                  fetchpriority="low"
                  alt="facebook"
                  width="40"
                  height="40"
                />
              </span>
              <span class="social-text" *ngIf="false">{{
                "footer.facebook" | translate
              }}</span>
            </a>
          </li>
          <li class="menu-list-items menu-list-items--linkedin">
            <a
              href="https://www.linkedin.com/company/umangapp/"
              target="_blank"
              title="Linkedin"
            >
              <span class="sociaicon">
                <img
                  imgFallback
                  src="https://media.umangapp.in/cdn/landing/theme/icons/linkedin.svg"
                  loading="lazy"
                  fetchpriority="low"
                  alt="linkedIn"
                  width="40"
                  height="40"
                />
              </span>
              <span class="social-text" *ngIf="false">{{
                "footer.linkedIn" | translate
              }}</span>
            </a>
          </li>
          <li class="menu-list-items menu-list-items--youtube">
            <a
              href="https://www.youtube.com/channel/UCejhcTgTo0PHDp3rrrM7jKg"
              target="_blank"
              title="youTube"
            >
              <span class="sociaicon">
                <img
                  imgFallback
                  src="https://media.umangapp.in/cdn/landing/theme/icons/youtube.svg"
                  loading="lazy"
                  fetchpriority="low"
                  alt="youtube"
                  width="40"
                  height="40"
                />
              </span>
              <span class="social-text" *ngIf="false">{{
                "footer.youTube" | translate
              }}</span>
            </a>
          </li>
          <li class="menu-list-items menu-list-items--instagram">
            <a
              href="https://www.instagram.com/official.umang/"
              target="_blank"
              title="Instagram"
            >
              <span class="sociaicon">
                <img
                  imgFallback
                  src="https://media.umangapp.in/cdn/landing/theme/icons/instagram.svg"
                  loading="lazy"
                  fetchpriority="low"
                  alt="instagram"
                  width="40"
                  height="40"
                />
              </span>
              <span class="social-text" *ngIf="false">{{
                "footer.instagram" | translate
              }}</span>
            </a>
          </li>
          <li class="menu-list-items menu-list-items--twitter">
            <a
              href="https://twitter.com/UmangOfficial_"
              target="_blank"
              title="Twitter"
            >
              <span class="sociaicon">
                <img
                  imgFallback
                  src="https://media.umangapp.in/cdn/landing/theme/icons/x.svg"
                  loading="lazy"
                  fetchpriority="low"
                  alt="twitter"
                  width="40"
                  height="40"
                />
              </span>
              <span class="social-text" *ngIf="false">{{
                "footer.twitter" | translate
              }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="scanner download-right">
      <picture>
        <source
          srcset="https://media.umangapp.in/cdn/landing/theme/qrcode.webp"
        />
        <img
          imgFallback
          loading="lazy"
          fetchpriority="low"
          src="https://media.umangapp.in/cdn/landing/theme/qrcode.png"
          alt="UMANG QR code"
          class="resp-image"
          width="479px"
          height="530px"
        />
      </picture>
    </div>
  </div>
</div>
